import { render, staticRenderFns } from "./WorksReadonlyPanel.vue?vue&type=template&id=bb596d00"
import script from "./WorksReadonlyPanel.vue?vue&type=script&lang=js"
export * from "./WorksReadonlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports